export default __webpack_public_path__ + "static/media/Icon_Arrow_right.db3af661.svg";